import { render, staticRenderFns } from "./SchoolPopup.vue?vue&type=template&id=3685377c&scoped=true"
import script from "./SchoolPopup.vue?vue&type=script&lang=js"
export * from "./SchoolPopup.vue?vue&type=script&lang=js"
import style0 from "./SchoolPopup.vue?vue&type=style&index=0&id=3685377c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3685377c",
  null
  
)

export default component.exports